import React from 'react'
import Box from '@mui/material/Box'
import MessagesMenu from './Messages'
import { ShopsMenu } from './Shops'
import { UserMenu } from './User'
import { useIsGarageAdmin } from 'utils/Subscription/PermissionSelector'
import { RequiredPermission } from 'utils/Subscription/RequiredPermissions'
import { PERMISSION_CLOCKINGACTIONS_DAY, PERMISSION_CLOCKINGACTIONS_READ } from 'utils/Subscription/Permissions'
import { TimeRegistrationMenu } from './TimeRegistration'
import SetupWizard from 'app/menu/components/TopBarV1/setupWizard/SetupWizard'
import { HelpMenu } from './Help'
import { CarsysAppBar, CarsysAppBarProps } from 'app/menu/components/TopBar/AppBar'
import { TopSearch } from '@cbgms/components/src/top-search/search-v1/TopSearch'
import { TopSearchContextProvider } from '../Search/TopSearchContextProvider'

export interface Props extends CarsysAppBarProps {}

export const TopBar: React.FC<Props> = ({ open, drawerWidthOpen, drawerWidthClosed, drawerVisible }) => {
  const isGarageAdmin = useIsGarageAdmin()
  const shouldShowSearch = !isGarageAdmin

  return (
    <CarsysAppBar open={open} drawerVisible={drawerVisible} drawerWidthOpen={drawerWidthOpen} drawerWidthClosed={drawerWidthClosed}>
      {shouldShowSearch && (
        <TopSearchContextProvider>
          <TopSearch />
        </TopSearchContextProvider>
      )}
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
        <SetupWizard />
        <RequiredPermission permission={[PERMISSION_CLOCKINGACTIONS_READ, PERMISSION_CLOCKINGACTIONS_DAY]}>
          <TimeRegistrationMenu />
        </RequiredPermission>
        <MessagesMenu />
        <ShopsMenu />
        <UserMenu />
        <HelpMenu />
      </Box>
    </CarsysAppBar>
  )
}

export default TopBar
